import { Locale } from 'chaika-enums';
export const finance = {
    reconciliation: {
        [Locale.Ru]: 'Сверка итогов',
        [Locale.Am]: 'Արդյունքների ստուգում',
        [Locale.En]: 'Reconciliation',
        [Locale.Pt]: 'Conciliação',
        [Locale.Ge]: 'შედეგების შერიგება',
    },
    reconcile: {
        [Locale.Ru]: 'Сверить итоги',
        [Locale.Am]: 'Ստուգել արդյունքները',
        [Locale.En]: 'Reconcile',
        [Locale.Pt]: 'Conciliar',
        [Locale.Ge]: 'შეადარეთ შედეგები',
    },
    paymentsReport: {
        [Locale.Ru]: 'Отчет об оплатах',
        [Locale.Am]: 'Վճարումների հաշվետվություն',
        [Locale.En]: 'Payment report',
        [Locale.Pt]: 'Relatório de pagamentos',
        [Locale.Ge]: 'Payment report',
    },
    sendingPaymentsReportTitle: {
        [Locale.Ru]: 'Отправляем отчет об оплатах...',
        [Locale.Am]: 'Ուղարկում ենք վճարումների հաշվետվությունը...',
        [Locale.En]: 'Sending payment report...',
        [Locale.Pt]: 'Enviando relatório de pagamentos...',
        [Locale.Ge]: 'Sending payment report...',
    },
    sendingPaymentsReportDescription: {
        [Locale.Ru]: 'Отправка отчета может занять некоторое время',
        [Locale.Am]: 'Հաշվետվության ուղարկումը կարող է որոշ ժամանակ տևել',
        [Locale.En]: 'Sending report can take a while',
        [Locale.Pt]: 'O envio do relatório pode levar algum tempo',
        [Locale.Ge]: 'Sending report can take a while',
    },
    sendingPaymentsReportDoneDescription: {
        [Locale.Ru]: 'Отчет отправлен',
        [Locale.Am]: 'Հաշվետվությունն ուղարկված է',
        [Locale.En]: 'Report sent',
        [Locale.Pt]: 'Relatório enviado',
        [Locale.Ge]: 'Report sent',
    },
    checkIntegration: {
        [Locale.Ru]: `Чековая интеграция`,
        [Locale.Am]: `Կտրոնային ինտեգրացիա`,
        [Locale.En]: `Check integration`,
        [Locale.Pt]: 'Integração de recibos',
        [Locale.Ge]: `Check integration`,
    },
    selectIntegrationType: {
        [Locale.Ru]: `Выберите тип интеграции`,
        [Locale.Am]: `Ընտրեք ինտեգրացիայի տեսակը`,
        [Locale.En]: `Select integration type`,
        [Locale.Pt]: 'Selecionar tipo de integração',
        [Locale.Ge]: `Select integration type`,
    },
    ffdVersion: {
        [Locale.Ru]: `Версия ФФД`,
        [Locale.Am]: `ՖՖԴ տարբերակ`,
        [Locale.En]: `FFD version`,
        [Locale.Pt]: `Versão FFD`,
        [Locale.Ge]: `FFD version`,
    },
    paymentMethods: {
        [Locale.Ru]: `Методы оплат`,
        [Locale.Am]: `Վճարման եղանակներ`,
        [Locale.En]: `Payment methods`,
        [Locale.Pt]: 'Métodos de pagamento',
        [Locale.Ge]: `Payment methods`,
    },
    credentials: {
        [Locale.Ru]: `Учетные данные`,
        [Locale.Am]: `Հաշվի տվյալներ`,
        [Locale.En]: `Credentials`,
        [Locale.Pt]: 'Credenciais',
        [Locale.Ge]: `Credentials`,
    },
    paymentIntegrationNotFound: {
        [Locale.Ru]: `Платежная интеграция не найдена`,
        [Locale.Am]: `Վճարային ինտեգրացիան չի գտնվել`,
        [Locale.En]: `Payment integration not found`,
        [Locale.Pt]: 'Integração de pagamento não encontrada',
        [Locale.Ge]: `Payment integration not found`,
    },
    paymentIntegration: {
        [Locale.Ru]: `Платежная интеграция`,
        [Locale.Am]: `Վճարային ինտեգրացիա`,
        [Locale.En]: `Payment integration`,
        [Locale.Pt]: 'Integração de pagamento',
        [Locale.Ge]: `Payment integration`,
    },
    paymentDevice: {
        [Locale.Ru]: `Устройство оплаты`,
        [Locale.Am]: `Վճարման սարքավորում`,
        [Locale.En]: `Payment device`,
        [Locale.Pt]: 'Dispositivo de pagamento',
        [Locale.Ge]: `Payment device`,
    },
    deviceNotFound: {
        [Locale.Ru]: `Устройство не найдено`,
        [Locale.Am]: `Սարքավորումը չի գտնվել`,
        [Locale.En]: `Device not found`,
        [Locale.Pt]: 'Dispositivo não encontrado',
        [Locale.Ge]: `Device not found`,
    },
    checkIntegrationNotFound: {
        [Locale.Ru]: `Чековая интеграция не найдена`,
        [Locale.Am]: `Կտրոնային ինտեգրացիան չի գտնվել`,
        [Locale.En]: `Check integration not found`,
        [Locale.Pt]: 'Integração de recibos não encontrada',
        [Locale.Ge]: `Check integration not found`,
    },
    workplaces: {
        [Locale.Ru]: `Рабочие места`,
        [Locale.Am]: `Աշխատատեղեր`,
        [Locale.En]: `Workplaces`,
        [Locale.Pt]: 'Locais de trabalho',
        [Locale.Ge]: `Workplaces`,
    },
    creatingPaymentWorkplace: {
        [Locale.Ru]: `Новое рабочее место`,
        [Locale.Am]: `Նոր աշխատատեղ`,
        [Locale.En]: `New workplace`,
        [Locale.Pt]: 'Novo local de trabalho',
        [Locale.Ge]: `ახალი სამუშაო ადგილი`,
    },
    editingPaymentWorkplace: {
        [Locale.Ru]: `Редактирование рабочего места`,
        [Locale.Am]: `Աշխատատեղի խմբագրում`,
        [Locale.En]: `Editing a workplace`,
        [Locale.Pt]: 'Editando um local de trabalho',
        [Locale.Ge]: `სამუშაო ადგილის რედაქტირება`,
    },
    addPaymentWorkplace: {
        [Locale.Ru]: `Добавить рабочее место`,
        [Locale.Am]: `Ավելացնել աշխատատեղ`,
        [Locale.En]: `Add workplace`,
        [Locale.Pt]: 'Adicionar local de trabalho',
        [Locale.Ge]: `სამუშაო ადგილის დამატება`,
    },
    paymentWorkplace: {
        [Locale.Ru]: `Рабочее место`,
        [Locale.Am]: `Աշխատատեղ`,
        [Locale.En]: `Workplace`,
        [Locale.Pt]: 'Local de trabalho',
        [Locale.Ge]: `სამუშაო ადგილი`,
    },
    selectPaymentWorkplace: {
        [Locale.Ru]: `Выберите рабочее место`,
        [Locale.Am]: `Ընտրեք աշխատատեղը`,
        [Locale.En]: `Select a workplace`,
        [Locale.Pt]: 'Selecione o local de trabalho',
        [Locale.Ge]: `აირჩიეთ სამუშაო ადგილი`,
    },
    paymentWorkplaceLastTime: {
        [Locale.Ru]: `В прошлый раз`,
        [Locale.Am]: `Նախորդ անգամ`,
        [Locale.En]: `Last time`,
        [Locale.Pt]: 'Da última vez',
        [Locale.Ge]: `ბოლოს`,
    },
    selectPaymentWorkplaceToLoadMethods: {
        [Locale.Ru]: `Выберите рабочее место — после этого загрузим доступные способы оплаты`,
        [Locale.Am]: `Ընտրեք աշխատատեղը, որից հետո կբեռնենք հասանելի վճարման եղանակները`,
        [Locale.En]: `Select a workplace to load the available payment methods`,
        [Locale.Pt]: 'Selecione o local de trabalho para carregar os métodos de pagamento disponíveis',
        [Locale.Ge]: `აირჩიეთ სამუშაო ადგილი, რის შემდეგაც ჩავტვირთავთ გადახდის ხელმისაწვდომ მეთოდებს`,
    },
    paymentMethodsOnWorkplace: {
        [Locale.Ru]: `Способы оплаты на этом месте`,
        [Locale.Am]: `Վճարման եղանակներն այս աշխատատեղում`,
        [Locale.En]: `Payment methods at this workplace`,
        [Locale.Pt]: 'Métodos de pagamento neste local',
        [Locale.Ge]: `გადახდის მეთოდები ამ ადგილზე`,
    },
    creatingPaymentMethod: {
        [Locale.Ru]: `Создание метода оплаты`,
        [Locale.Am]: `Վճարման եղանակի ստեղծում`,
        [Locale.En]: `Creating a payment method`,
        [Locale.Pt]: 'Criando um método de pagamento',
        [Locale.Ge]: `Creating a payment method`,
    },
    editingPaymentMethod: {
        [Locale.Ru]: `Редактирование метода оплаты`,
        [Locale.Am]: `Վճարման եղանակի խմբագրում`,
        [Locale.En]: `Editing a payment method`,
        [Locale.Pt]: 'Editando um método de pagamento',
        [Locale.Ge]: `Editing a payment method`,
    },
    canSavePaymentMethod: {
        [Locale.Ru]: `Можно сохранить метод оплаты`,
        [Locale.Am]: `Կարող է պահպանել վճարման եղանակը`,
        [Locale.En]: `Can save payment method`,
        [Locale.Pt]: 'Pode salvar o método de pagamento',
        [Locale.Ge]: `თქვენ შეგიძლიათ შეინახოთ გადახდის მეთოდი`,
    },
    canSplit: {
        [Locale.Ru]: `Сплитовый метод оплаты`,
        [Locale.Am]: `Բաժանվող վճարման եղանակ`,
        [Locale.En]: `Split payment method`,
        [Locale.Pt]: 'Método de pagamento dividido',
        [Locale.Ge]: `გაყოფადი გადახდის მეთოდი`,
    },
    appointmentInOrganization: {
        [Locale.Ru]: `Назначение в организации`,
        [Locale.Am]: `Նշանակում կազմակերպությունում`,
        [Locale.En]: `Appointment in the organization`,
        [Locale.Pt]: 'Nomeação na organização',
        [Locale.Ge]: `Appointment in the organization`,
    },
    planNotFound: {
        [Locale.Ru]: `Программа не найдена`,
        [Locale.Am]: `Ծրագիրը չի գտնվել`,
        [Locale.En]: `Plan not found`,
        [Locale.Pt]: 'Plano não encontrado',
        [Locale.Ge]: `Plan not found`,
    },
    patientIsNotAssinged: {
        [Locale.Ru]: `Пациент не был выбран`,
        [Locale.Am]: `Պացիենտն ընտրված չէր`,
        [Locale.En]: `Patient haven't been assigned`,
        [Locale.Pt]: 'Paciente não foi atribuído',
        [Locale.Ge]: `Patient haven't been assigned`,
    },
    doctorIsNotAssinged: {
        [Locale.Ru]: `Доктор не был выбран`,
        [Locale.Am]: `Բժիշկն ընտրված չէր`,
        [Locale.En]: `Doctor haven't been assigned`,
        [Locale.Pt]: 'Médico não foi atribuído',
        [Locale.Ge]: `Doctor haven't been assigned`,
    },
    createChat: {
        [Locale.Ru]: `Создать чат`,
        [Locale.Am]: `Ստեղծել չաթ`,
        [Locale.En]: `Create chat`,
        [Locale.Pt]: 'Criar bate-papo',
        [Locale.Ge]: `Create chat`,
    },
    chatIsBeingCreated: {
        [Locale.Ru]: `Чат создается...`,
        [Locale.Am]: `Չաթը ստեղծվում է...`,
        [Locale.Pt]: `Um chat está a ser criado...`,
        [Locale.En]: `Сhat is being created...`,
        [Locale.Ge]: `Сhat is being created...`,
    },
    createTopic: {
        [Locale.Ru]: 'Создать топик',
        [Locale.Am]: 'Ստեղծել թոփիկ',
        [Locale.En]: 'Create topic',
        [Locale.Pt]: 'Criar tópico',
        [Locale.Ge]: 'Create topic',
    },
    topic: {
        [Locale.Ru]: 'Топик',
        [Locale.Am]: 'Թոփիկ',
        [Locale.En]: 'Topic',
        [Locale.Pt]: 'Tópico',
        [Locale.Ge]: 'Topic',
    },
    createSubscription: {
        [Locale.Ru]: `Создать программу`,
        [Locale.Am]: `Ստեղծել ծրագիր`,
        [Locale.En]: `Create subscription`,
        [Locale.Pt]: 'Criar assinatura',
        [Locale.Ge]: `Create subscription`,
    },
    registerInChat: {
        [Locale.Ru]: `Зарегистрироваться в чате`,
        [Locale.Am]: `Գրանցվել չաթում`,
        [Locale.En]: `Register in chat`,
        [Locale.Pt]: 'Cadastre-se no bate-papo',
        [Locale.Ge]: `Register in chat`,
    },
    registerInChatAgain: {
        [Locale.Ru]: `Зарегистрироваться в чате повторно`,
        [Locale.Am]: `Կրկին գրանցվել չաթում`,
        [Locale.En]: `Register in chat again`,
        [Locale.Pt]: 'Cadastre-se no bate-papo novamente',
        [Locale.Ge]: `Register in chat again`,
    },
    passEpisodes: {
        [Locale.Ru]: `Передать эпизоды`,
        [Locale.Am]: `Փոխանցել էպիզոդները`,
        [Locale.En]: `Pass episodes`,
        [Locale.Pt]: 'Passar episódios',
        [Locale.Ge]: `ეპიზოდების გადაცემა`,
    },
    needToPassEpisodesToAnotherUser: {
        [Locale.Ru]: `Необходимо передать эпизоды другому пользователю`,
        [Locale.Am]: `Անհրաժեշտ է փոխանցել էպիզոդներն այլ օգտատիրոջ`,
        [Locale.En]: `It is necessary to transfer the episodes to another user`,
        [Locale.Pt]: 'É necessário transferir os episódios para outro usuário',
        [Locale.Ge]: `საჭიროა ეპიზოდების სხვა მომხმარებელზე გადაცემა`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
